import {
    SAVE_FORGOTPASSWORD_STARTED,
    SAVE_FORGOTPASSWORD_COMPLETED,
    SAVE_FORGOTPASSWORD_FAILED,
    SAVE_FORGOTUSERNAME_STARTED,
    SAVE_FORGOTUSERNAME_COMPLETED,
    SAVE_FORGOTUSERNAME_FAILED,

    
    
} from '../actions/Forgotpassword';

const intialForgotpasswordData= {
    status: {
        statusCode: 300,
        statusDisplay: "",
        statusValue: true
    },
    items: [],
    passwordInput: {       
        userId:""
    
    },
    isLoading: true,
    isFormSubmit: false,
    isLoggedIn: false,
    error: ''
};
export const forgotpasswordData = (state = intialForgotpasswordData, action: any) => {
   
 
    switch (action.type) {
       
        case SAVE_FORGOTPASSWORD_STARTED:
           return {
                ...state,
                isLoading: true,    
                items:[],
                isFormSubmit:false,
                userInput: action.input
            };

        case SAVE_FORGOTPASSWORD_COMPLETED:
           
            return {
                ...state,
                isLoading: false,
                isFormSubmit:true,
                status: action.payload,
                items: action.payload
                };
            
        case SAVE_FORGOTPASSWORD_FAILED:
            return {
                ...state,
                isLoading: true,
            };

   

        default:
            return state;
    }
};

export const forgotUsernameData = (state = intialForgotpasswordData, action: any) => {
   
 
    switch (action.type) {
       
        case SAVE_FORGOTUSERNAME_STARTED:
           return {
                ...state,
                isLoading: true,    
                items:[],
                isFormSubmit:false,
                userInput: action.input
            };

        case SAVE_FORGOTUSERNAME_COMPLETED:
           
            return {
                ...state,
                isLoading: false,
                isFormSubmit:true,
                status: action.payload,
                items: action.payload
                };
            
        case SAVE_FORGOTUSERNAME_FAILED:
            return {
                ...state,
                isLoading: true,
            };

   

        default:
            return state;
    }
};